__turbopack_context__.v({
  "className": "geist_920549e9-module__AMEKZW__className",
  "variable": "geist_920549e9-module__AMEKZW__variable",
});
